'use strict';

if (document.querySelector('.video-show')) {
  var modal = document.querySelector('.video-modal'),
      video = document.getElementById('modal-video');

  // the modal needs to be a direct child of the body otherwise the z-index is messed up
  modal.parentElement.removeChild(modal);
  document.body.appendChild(modal);

  document.querySelector('.video-show').addEventListener('click', function () {
    modal.style.display = 'block';
    video.play();
  });
  document.querySelector('.video-close').addEventListener('click', function () {
    modal.style.display = 'none';
    video.pause();
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/homepage/video-modal.js
// module id = ./js/homepage/video-modal.js
// module chunks = 0